import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import {removeHazmatItem} from '../../../data/labelInfos/index.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {getRates} from '../../../data/labelInfos/rateRequest.js'

export const MODAL_FORM = 'REMOVE_HAZMAT_ITEM_MODAL'

export function showRemoveHazmatItemModal(
  labelInfoID,
  shipperType,
  packageIndex,
  hazmatItemIndex,
) {
  setForm(MODAL_FORM, {
    labelInfoID,
    packageIndex,
    shipperType,
    hazmatItemIndex,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export async function remove() {
  const {labelInfoID, packageIndex, shipperType, hazmatItemIndex} =
    modalFormSelector(getState())

  removeHazmatItem(labelInfoID, packageIndex, shipperType, hazmatItemIndex)

  closeModal()

  showMessageToast('Hazmat info was successfully removed.')

  await getRates([labelInfoID])
}

function RemoveHazmatItemModal() {
  return (
    <ConfirmModal
      title="Remove HazMat Declaration"
      onConfirm={() => remove()}
      onCancel={() => closeModal()}
    >
      <p className="fs-01 lh-md">
        Are you sure you want to remove this declaration?
      </p>
    </ConfirmModal>
  )
}

export default onlyIfForm(RemoveHazmatItemModal, modalFormSelector)
